import React from 'react';

const WazeEmbed = () => {
  const wazeLink = "https://waze.com/ul?a=share_drive&locale=es-419&sd=fYS-cloKgqFRphHiJw-sd&env=row&utm_source=waze_app&utm_campaign=share_drive";

  return (
    <div className="flex flex-col items-center w-full max-w-2xl mx-auto p-6 bg-gray-50 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Mapa de Waze Compartido</h2>

      <iframe
        src={wazeLink}
        className="w-full h-96"
        style={{ border: 'none' }}
        title="Mapa de Waze"
      />
      
      <p className="mt-4 text-gray-600">
        Este es el mapa compartido de Waze. Si no se carga correctamente, intenta abrir el enlace directamente en una nueva pestaña.
      </p>
    </div>
  );
};

export default WazeEmbed;